import Vue from 'vue';
import axios from 'axios';
import {
  BAN_USER,
  UNBAN_USER,
  FETCH_USERS_PENDING_FAILED,
  FETCH_USERS_PENDING_SUCCESS,
  TOGGLE_SPINNER,
} from '../mutation-types';

export const state = {
  all: [],
  isLoading: false,
};

export const mutations = {
  [FETCH_USERS_PENDING_SUCCESS](state, users) {
    state.all = users;
  },

  [FETCH_USERS_PENDING_FAILED](state) {
    state.all = [];
  },

  [BAN_USER](state, user) {
    let index = state.all.indexOf(user);
    state.all.splice(index, 1);
  },

  [UNBAN_USER](state, user) {
    let index = state.all.indexOf(user);
    state.all.splice(index, 1);
  },

  [TOGGLE_SPINNER](state) {
    state.isLoading = !state.isLoading;
  },
};

export const actions = {
  async fetch({ commit }) {
    try {
      const { data: { data } } = await axios.get('/api/pending/users');
      commit(FETCH_USERS_PENDING_SUCCESS, data);
    } catch (e) {
      commit(FETCH_USERS_PENDING_FAILED);
    }
  },

  async ban({ dispatch, commit }, user) {
    try {
      dispatch('toggleSpinner');

      await axios.patch(`/api/users/${user.id}/ban`);
      commit(BAN_USER, user);

      dispatch('toast', 'User flagged.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async unban({ dispatch, commit }, user) {
    try {
      dispatch('toggleSpinner');

      await axios.patch(`/api/users/${user.id}/unban`);
      commit(UNBAN_USER, user);

      dispatch('toast', 'User unflagged.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  toggleSpinner({ commit }) {
    commit(TOGGLE_SPINNER);
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/userspending.js